import api from './api'

const ctacteService = {}

ctacteService.consultar = async function(id) {
    return api.get('/CtaCte/' + id).then(res => res.data);
}

export default ctacteService